<small *ngIf="phoneLabel">{{ phoneLabel | translate }}</small>
<section
  *ngIf="!isMobile; else PhoneButton"
  class="link-with-icon"
  [ngClass]="{ 'pt-4': phoneLabel, 'pt-8': !phoneLabel }"
>
  <a class="not-clickable-on-desktop" [phone]="phoneNumber">
    <dgx-components-icon name="phone" size="sm"></dgx-components-icon>
    <span>{{ phoneNumber }}</span>
  </a>
</section>
<ng-template #PhoneButton>
  <a [phone]="phoneNumber" class="number-button">
    <dgx-components-button variant="primary">
      {{ 'MMR.TRACKER.CALL_TO_REBOOK' | translate }}
    </dgx-components-button>
  </a>
</ng-template>
